import {
  takeLatest,
  all,
  delay,
  takeEvery,
  select,
  call,
  put,
} from 'redux-saga/effects';
import triggerActionsList from '../config/triggerActionsList';
import {
  getActiveEditorEntityId,
  getActiveEntityCollectionPath,
} from '../../../reducers';
import {
  CREATE_PREVIEW_THUMBNAIL,
  SYNC_PREVIEW_THUMBNAIL,
} from '../constants/actions';
import { nodeToImageBlob } from '../utils/screenshotUtils';
import postPreviewThumbnail from '../api/postPreviewThumbnail';
import { THUMBNAIL_GENERATOR_ID } from '../constants/idList';
import {
  createPreviewThumbnail,
  endThumbnailGeneration,
  startThumbnailGeneration,
} from '../actions';
import isThumbnailOutdated from '../utils/isThumbnailOutdated';
import { WAIT_FOR_SURVEY_CHANGE_TIME } from '../constants/time';

export function* createThumbnail(id) {
  const activeEntityId = yield select(getActiveEditorEntityId);
  const collectionPath = yield select(getActiveEntityCollectionPath);
  if (id !== activeEntityId) {
    yield put(endThumbnailGeneration(id));
    return;
  }
  yield put(startThumbnailGeneration(id));
  yield delay(500); // giving time for 'didMount" DOM related calculation @sinslav
  try {
    const blob = yield call(
      nodeToImageBlob,
      document.getElementById(THUMBNAIL_GENERATOR_ID),
    );
    yield call(postPreviewThumbnail, collectionPath, id, blob);
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.error(`Error generating preview: ${e}`);
    }
  }
  yield put(endThumbnailGeneration(id));
}

function* handleCreateThumbnail(action) {
  yield delay(WAIT_FOR_SURVEY_CHANGE_TIME);
  yield createThumbnail(action.payload);
}

function* handleSynPreviewThumbnail({ payload }) {
  if (isThumbnailOutdated(payload)) {
    yield put(createPreviewThumbnail(payload.id));
  }
}

function* handleTriggerChangeActions() {
  const id = yield select(getActiveEditorEntityId);
  yield put(createPreviewThumbnail(id));
}

export default function*() {
  yield all([
    takeLatest(CREATE_PREVIEW_THUMBNAIL, handleCreateThumbnail),
    takeEvery(triggerActionsList, handleTriggerChangeActions),
    takeEvery(SYNC_PREVIEW_THUMBNAIL, handleSynPreviewThumbnail),
  ]);
}
